import { Phone } from "lucide-react";
import { CallRailPhone } from "@/components/shared/CallRailPhone";
import { useLocationContext } from "@/hooks/useLocationContext";

export const BBQMobilePhoneCTA = () => {
  const { region } = useLocationContext();

  return (
    <div className="fixed bottom-4 right-4 z-50 md:hidden">
      <CallRailPhone 
        source={`mobile_sticky_cta_${region}`}
        className="bg-orange-500 hover:bg-orange-600 text-white rounded-full p-4 shadow-lg flex items-center gap-2 transition-all active:scale-95 callrail-phone"
      >
        <Phone className="w-6 h-6" />
        <span className="font-bold text-sm">Call Now</span>
      </CallRailPhone>
    </div>
  );
};
